import myAxios from "./axiositeachWrapper";
import Config from "../_config/config";

/**
 * Overwrite Test Time (Provide Grace Time) — iteach client for the nodefork
 * port of the Java studentReport.do?reqCode=preActivateStudentTest flow.
 * Backend group: /api/v1/overwrite-test-time.
 */

export interface IdName {
  id: number;
  name: string;
}

export interface TestDataBean {
  name: string;
  keyword: string; // Student Code (or "--")
  id: number; // testId
  endDate: string; // formatted test end date (cut-off default)
  enquiryId: number;
  elapsedTime: string;
  status: string; // e.g. "Self Submitted [00:00:00]"
  testTime: string;
}

export interface ActivationListResponse {
  testDataBeans: TestDataBean[];
  testId: number;
  testName: string;
  showTime: boolean;
  testTime: number;
  searchCriteria: {
    year: number;
    category: number;
    test: { id: number; name: string };
    enquiryId: string | null;
    studentCode: string | null;
    hallTicket: string | null;
    testSubmitStatus: string;
  };
}

export interface ActivationListParams {
  year: number;
  testCategory: number;
  test: number;
  enquiryId?: string;
  studentCode?: string;
  hallTicket?: string;
  testSubmitStatus: number; // 3 = Completed, 1 = In Progress/Partial
}

export interface GraceTimeParams {
  testId: number;
  enquiryId?: number;
  studentCode?: string;
  elapsedTime?: number; // minutes
  cutoffDateTime: string; // "dd-MM-yyyy HH:mm:ss"
}

export interface GraceTimeResponse {
  type: number; // 1 = success, 0 = failure, 2 = validation block
  message: string;
}

class OverwriteTestTimeService {
  private baseUrl = `${Config.nodeSiteUrl}v1/overwrite-test-time`;

  /** Years + Test Categories for the search form. */
  async getYearsAndCategories(): Promise<{ years: IdName[]; testCategories: IdName[] }> {
    const response: any = await myAxios.get(`${this.baseUrl}/years-categories`);
    return {
      years: response.data?.years || [],
      testCategories: response.data?.testCategories || [],
    };
  }

  /** Online tests for a year (+ optional category). */
  async getTests(yearId: number, categoryId: number): Promise<IdName[]> {
    const response: any = await myAxios.get(`${this.baseUrl}/tests`, {
      params: { yearId, categoryId },
    });
    return response.data?.tests || [];
  }

  /** Search: students who took / are taking the test. */
  async fetchActivationList(params: ActivationListParams): Promise<ActivationListResponse> {
    const response: any = await myAxios.post(`${this.baseUrl}/activation-list`, params);
    return response.data;
  }

  /** Activate / Add Extra Time (grace time). */
  async provideGraceTime(params: GraceTimeParams): Promise<GraceTimeResponse> {
    const response: any = await myAxios.post(`${this.baseUrl}/grace-time`, params);
    return response.data;
  }
}

export default new OverwriteTestTimeService();
